import { isValidElement, ReactNode } from 'react';
import { renderChildren } from '@fiverr-private/ui_utils';
import { TabContextType, TabPanelPropsInternalProps } from '../types';
import { tabId as getTabId, tabPanelId } from '../helpers';

export const renderTabPanelChild =
    ({ idPrefix, selectedIndex, isLazy, variant, tabsRef }: TabContextType) =>
    (child: ReactNode, index: number) => {
        if (!isValidElement(child)) return null;

        const { isDisabled, wasSelected } = tabsRef.current[index] ?? {};
        const isSelected = index === selectedIndex && !isDisabled;
        const isRendered = !(isDisabled && !wasSelected) && (!isLazy || isSelected || wasSelected);

        return renderChildren(child, {
            isSelected,
            isRendered,
            variant,
            id: tabPanelId(idPrefix, index),
            tabId: getTabId(idPrefix, index),
        } satisfies Omit<TabPanelPropsInternalProps, 'children'>);
    };
